import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService, ConfirmationService, Message } from "primeng/api";

import { PedidoStatus, PedidoStatusFluxo } from '../models/pedido-status';
import { PedidoStatusService } from '../pedido-status.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { Usuario, Perfil, PerfilChecked } from '../../usuario/models/usuario';

@Component({
  selector: 'cria-pedido-status-fluxo',
  templateUrl: './pedido-status-fluxo.component.html',
  styleUrls: ['./pedido-status-fluxo.component.scss']
})
export class PedidoStatusFluxoComponent implements OnInit {

  public listaFluxo: PedidoStatusFluxo[] = [];
  public listaPerfil: Perfil[] = [];
  //public listaPerfilChecked: PerfilChecked[] = [];
  public listaStatus: PedidoStatus[] = [];

  public fluxo: PedidoStatusFluxo;
  public selectedOrigem: PedidoStatus;
  public selectedDestino: PedidoStatus;
  public selectedPerfil: Perfil[] = [];
  public listaPerfilParam: string = "";

  public flagEdit: boolean = true;
  public flagDelete: boolean = true;

  public displayMsg: boolean = false;
  public caixaDialog: boolean;
  public perfilDialog: boolean;
  public submitted: boolean;



  constructor(public usuarioService: UsuarioService,
    public pedidoStatusService: PedidoStatusService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.selectedOrigem = { nome: '', codStatus: '', idPedidoStatus: 0 }
    this.selectedDestino = { nome: '', codStatus: '', idPedidoStatus: 0 }
    this.getPerfil();
    this.getFluxo();
    this.getStatus();
  }


  getFluxo() {
    this.pedidoStatusService.getFluxo().subscribe(
      (res) => {
        if (res) {
          this.listaFluxo = res;        
        }
      },
      err => {
        console.log("ERRO PEDIDO-STATUS-FLUXO - FLUXO ");
        console.log(err);
      }
    );
  }

  getPerfil() {
    this.usuarioService.getPerfil().subscribe(
      (res) => {
        if (res) {
          this.listaPerfil = res;
        }
      },
      err => {
        console.log("ERRO PEDIDO-STATUS-FLUXO - PERFIL ");
        console.log(err);
      }
    );
  }

  getPerfilChecked(idPedidoStatusFluxo) {
    this.pedidoStatusService.getPerfilChecked(idPedidoStatusFluxo).subscribe(
      (res) => {
        if (res) {
          this.selectedPerfil = res;     
        }
      },
      err => {
        console.log("ERRO PEDIDO-STATUS-FLUXO - PERFIL-STATUS-FLUXO ");
        console.log(err);
      }
    );
  }

  getStatus() {
    this.pedidoStatusService.getStatus().subscribe(
      (res) => {
        if (res) {
          this.listaStatus = res;
        }
      },
      err => {
        console.log("ERRO PEDIDO-STATUS-FLUXO - STATUS ");
        console.log(err);
      }
    );
  }

  getSelectedStatus(idStatus: number) {
    return this.listaStatus.find(x => x.idPedidoStatus === idStatus);
  }

  getSelectedDestino(idStatus: number) {
    this.pedidoStatusService.getSelectedPerfil(idStatus).subscribe(
      (res) => {
        if (res) {
          this.selectedDestino = res;
        }
      },
      err => {
        console.log("ERRO PEDIDO-STATUS-FLUXO - SELECT DESTINO");
        console.log(err);
      }
    );
  }

  openNew() {
    this.fluxo = {};
    this.submitted = false;
    this.caixaDialog = true;
  }

  editFluxo(fluxo: PedidoStatusFluxo) {
    this.selectedOrigem = this.getSelectedStatus(fluxo.idPedidoStatusAtual);
    this.selectedDestino = this.getSelectedStatus(fluxo.idPedidoStatusNovo);
    this.fluxo = { ...fluxo };
    this.caixaDialog = true;
  }

  editPerfil(fluxo: PedidoStatusFluxo) {
    this.getPerfilChecked(fluxo.idPedidoStatusFluxo);    
    this.fluxo = { ...fluxo };
    this.perfilDialog = true;
  }

  deleteFluxo(fluxo: PedidoStatusFluxo) {
    console.log("del");
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja remover a operação: ' + fluxo.nome + '?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.pedidoStatusService
          .delFluxo(fluxo)
          .subscribe(
            () => {
              console.log("del1");
              this.getFluxo()
            },
            err => console.log(err)
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Operação removida com sucesso!', life: 3000 });
      }
    });

  }
 

  hideDialog() {
    this.caixaDialog = false;
    this.submitted = false;
  }

  hidePerfilDialog() {
    this.perfilDialog = false;
    this.submitted = false;
  }

  saveFluxo() {
    this.submitted = true;
    if (this.fluxo.nome.trim()) {
      if (this.fluxo.idPedidoStatusFluxo) {

        this.pedidoStatusService
          .updFluxo(this.fluxo)
          .subscribe(
            () => this.getFluxo(),
            err => console.log(err)
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fluxo atualizado com sucesso!', life: 3000 });
      } else {
        console.log(this.fluxo);
        this.pedidoStatusService
          .addFluxo(this.fluxo)
          .subscribe(
            () => this.getFluxo(),
            err => console.log(err)
          );

        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fluxo cadastrado com sucesso!', life: 3000 });
      }

      this.listaFluxo = [...this.listaFluxo];
      this.caixaDialog = false;
      this.fluxo = {};
    }
  }

  saveFluxoPerfil() {
     this.submitted = true;
     if (this.selectedPerfil) {

       this.pedidoStatusService
         .updFluxoPerfil(this.selectedPerfil, this.fluxo.idPedidoStatusFluxo)
         .subscribe(
           () => this.getFluxo(),
           err => console.log(err)
         );
       this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Perfis de acesso atualizados com sucesso!', life: 3000 });
     }     
    
     this.hidePerfilDialog();  
  }

  SetOrigem(status: PedidoStatus)
  {
    //this.fluxo.idPedidoStatusAtual = status.idPedidoStatus;
    this.fluxo.idPedidoStatusAtual = this.selectedOrigem.idPedidoStatus;
  }
  
  SetDestino(status: PedidoStatus)
  {
    //this.fluxo.idPedidoStatusNovo = status.idPedidoStatus;
    this.fluxo.idPedidoStatusNovo = this.selectedDestino.idPedidoStatus;
  }
}

